import React from "react";
import { useQuery } from "@apollo/react-hooks";

import { Button, Modal } from "components/common";

import { GET_PUSH_FUNDING_ADDRESSES_QUERY } from "../gql";

const NETWORK_MAPPING = {
  ach: "ACH",
  domestic_wire_us: "Wire",
};

const FundingInstructionModal = ({ isOpen, closeModal }) => {

  const { loading, error, data } = useQuery(GET_PUSH_FUNDING_ADDRESSES_QUERY);

  const render = () => {
    // TODO: make it pretty
    if (loading) { return <i className="fas fa-spinner fa-spin p-5" />; }
    if (error) {
      return error.message;
    }
    const addresses = data.getStripePushFundingAddresses;
    const renderAddress = (address) => {
      return <div>
        <p className="font-bold">Bank Name</p>
        <p className="">{address.aba.bank_name}</p>
        <p className="font-bold">Routing  Number</p>
        <p className="">{address.aba.routing_number}</p>
        <p className="font-bold">Account Number</p>
        <p className="">{address.aba.account_number}</p>
        <p className="font-bold">Networks</p>
        <p>{address.supported_networks?.map((network) => (NETWORK_MAPPING[network] || network)).join(" or ")}</p>
      </div>;
    };
    return <div>
      <h1> Fund your account </h1>
      <div>Use the following details to send money to your Card account. Funds should arrive within 3-5 business days.</div>
      <div className="mt-5">
        { addresses.map((address) => renderAddress(address))}
      </div>
    </div>;
  };

  return (
    <Modal
      isOpen={isOpen}
      close={closeModal}
      options={{ showCloseButton: true }}
    >
      <div
        className="flex flex-col justify-center items-center bg-white rounded-xl px-4 py-10"
        style={{ minWidth: 400, maxWidth: 400 }}
      >{render()}
      </div>
    </Modal>
  );
};

export const IssuingApprovedAddFunds = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  return (
    <div
      className="w-full px-4 py-2 shadow flex flex-col items-center"
      style={{ minWidth: 240 }}
    >
      <p className="font-bold mr-1 text-xl">Add Funds</p>
      <div className="flex flex-col h-full justify-center items-center">
        <Button onClick={() => { setModalOpen(true); }}>
          <p className="px-8">Add</p>
        </Button>
      </div>
      {modalOpen && <FundingInstructionModal isOpen={modalOpen} closeModal={() => setModalOpen(false)}/>}
    </div>
  );
};
